import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import sessionReducer from "./sessionReducer";
import themeReducer from "./themeReducer";
import WorkspaceReducer from "pages/WorkSpace/reducers/WorkspaceReducer";
import WorkspaceAdminReducer from "pages/WorkSpaceAdmin/reducers";
import WorkspaceAccessReducer from "pages/WorkSpaceAccess/reducers/WorkspaceAccessReducer";
import WorkspaceCategoriesReducer from "pages/WorkSpaceCategories/reducers/WorkspaceCategoriesReducer";
import WorkspaceApiExposureReducer from "pages/WorkSpaceApiExposure/reducers/WorkspaceApiExposureReducer";

import { ObjectsReducer, ObjectTypesReducer, RolesReducer ,UsersRoleReducer, RolesAccessReducer } from "pages/AccessManagement/reducers";

import { WorkspaceFormReducer } from "pages/WorkSpaceForm/reducers";

import commonReducer from "./commonReducer";
import WorkSpaceAccess from "pages/WorkSpaceAccess";


//import WorkspaceFormReducer from "pages/WorkSpaceForm/reducers/WorkspaceFormReducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["session", "themeState"],
};

const appReducer = combineReducers({
  workspaceState: WorkspaceReducer,
  workspaceAdminState: WorkspaceAdminReducer,
  workspaceFormState :WorkspaceFormReducer,
  workspaceAccessState: WorkspaceAccessReducer,
  session: sessionReducer,
  workspaceCategoriesState :WorkspaceCategoriesReducer,
  objectsState:ObjectsReducer,
  objectTypesState:ObjectTypesReducer,
  rolesState: RolesReducer,
  commonState: commonReducer,
  usersRoleState :UsersRoleReducer,
  rolesAccessState: RolesAccessReducer,
  themeState: themeReducer,
  workspaceApiExposureState: WorkspaceApiExposureReducer,
});

const RootReducer = (state, action) => {
  if (action.type === "TOKEN_EXPIRE" || action.type === "SESSION_LOGOUT") {
    state = undefined;
    localStorage.removeItem("token");
    sessionStorage.clear();
  }
  return appReducer(state, action);
};

export default persistReducer(persistConfig, RootReducer);
